import React, { useEffect } from "react";
import "./ManageCarList.css";

import {  Plus, Trash, ThreeDots } from "react-bootstrap-icons";

import { dashboard_vertical_three_dots } from "../../../assets/images";

import CreateProduct from "../../../components/MerchantDashboard/CreateProduct";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import { useState } from "react";
import { Car, ProductList, ProductDelete, ProductData } from "../../../types";

import { Dropdown, Pagination } from "react-bootstrap";
import CustomCheckBox from "../../customCheckbox";
import ConfirmationModal from "../../ConfirmationModal";

const ManageCarList = () => {
  const navigate = useNavigate();

  const [selectedStatus, setSelectedStatus] = useState("PENDING");
  const [carList, setCarList] = useState<Car[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [deletePayload, setDeletePayload] = useState<ProductDelete | null>(
    null
  );

  const [showCreateProduct, setShowCreateProduct] = useState(false);
  const accessToken = localStorage.getItem("access_token");

  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    } else {
      return null;
    }
  };

  const decodedToken = decodeToken(accessToken);

  const merchantId =
    decodedToken && decodedToken["merchant-id"]
      ? decodedToken["merchant-id"]
      : null;

  const businessArea =
    decodedToken && decodedToken["planet"] ? decodedToken["planet"] : null;

    const generatePageNumbers = (currentPage: number, totalPages: number) => {
      if (totalPages <= 7) {
        return Array.from({ length: totalPages }, (_, i) => i);
      }
    
      if (currentPage <= 3) {
        return [0, 1, 2, 3, -1, totalPages - 2, totalPages - 1];
      }
    
      if (currentPage >= totalPages - 4) {
        return [0, 1, -1, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1];
      }
    
      return [0, 1, -1, currentPage - 1, currentPage, currentPage + 1, -1, totalPages - 1];
    };

  const mutation = useMutation({
    mutationFn: (userData: ProductList) =>
      axiosInstance.post(
        `${API_URL.PRODUCT_LIST}?page=${currentPage}`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      ),

    onSuccess: (successResponse) => {
      console.log("successResponseproductlist", successResponse);
      setCarList(successResponse?.data.content || []);
      setTotalPages(successResponse?.data?.totalPages);
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        alert(error?.data?.message);
      }
    },
  });

  const getProductEditPayload = (
    productDetails: any,
    recordStatus: number
  ): ProductData => ({
    merchant_id: productDetails?.merchant_id || merchantId,
    shop_id: productDetails?.shop_id,
    business_area: productDetails?.business_area || businessArea,
    product_name:
      productDetails?.product_name || productDetails?.product_details_car?.sub_category,
    parent_category_id: productDetails?.parent_category_id,
    category_id: productDetails?.category_id || productDetails?.product_category_id,
    description:
      productDetails?.description || productDetails?.product_details_car?.description,
    unit_price: productDetails?.unit_price,
    gst: productDetails?.gst,
    variants_info: productDetails?.variants_info || [],
    custom_attributes: productDetails?.custom_attributes || [],
    buy_more_pay_less_option: productDetails?.buy_more_pay_less_option || null,
    toppings: productDetails?.toppings || [],
    product_images:
      productDetails?.product_images || productDetails?.product_details?.images || [],
    record_status: recordStatus,
    product_details_car: productDetails?.product_details_car,
    product_car_insurance: productDetails?.product_car_insurance,
  });

  const statusMutation = useMutation({
    mutationFn: async ({
      productId,
      recordStatus,
    }: {
      productId: string;
      recordStatus: number;
    }) => {
      const detailsResponse = await axiosInstance.get(
        `${API_URL.VIEW_PRODUCT_DETAILS}/${productId}`
      );
      const payload = getProductEditPayload(detailsResponse.data, recordStatus);

      return axiosInstance.put(`${API_URL.CREATE_PRODUCT}/${productId}`, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    },
    onSuccess: () => {
      mutation.mutate({
        merchant_id: merchantId,
        business_area: businessArea,
        status: selectedStatus || "PENDING",
      });
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        alert(error?.data?.message);
      }
      mutation.mutate({
        merchant_id: merchantId,
        business_area: businessArea,
        status: selectedStatus || "PENDING",
      });
    },
  });

  const handleStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedStatus(value);
    setCurrentPage(0);
    // mutation.mutate({
    //   merchant_id: merchantId,
    //   business_area: businessArea,
    //   status: value, // Use the extracted value here
    // });
  };

  const handleCarAvailabilityChange = (
    car: Car,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nextRecordStatus = event.target.checked ? 1 : 0;

    setCarList((prevList) =>
      prevList.map((item) =>
        item.product_id === car.product_id
          ? { ...item, record_status: nextRecordStatus }
          : item
      )
    );

    statusMutation.mutate({
      productId: car.product_id,
      recordStatus: nextRecordStatus,
    });
  };

  useEffect(() => {
    mutation.mutate({
      merchant_id: merchantId,
      business_area: businessArea,
      status: selectedStatus,
    });
  }, [currentPage, selectedStatus]);

  //-----------------------------
  const [visiblePages, setVisiblePages] = useState<number[]>(() => {
    return generatePageNumbers(0, totalPages);
  });
  useEffect(() => {
    setVisiblePages(generatePageNumbers(currentPage, totalPages));
  }, [currentPage, totalPages]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // const itemsPerPage = 8;
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // const currentItems = carList.slice(indexOfFirstItem, indexOfLastItem);

  const handleUploadModalOpen = () => {
    setShowCreateProduct(true);
  };

  const handleAddCar = () => {
    console.log("Button clicked!");
    localStorage.removeItem("carInformation");
    localStorage.removeItem("productImages");
    localStorage.removeItem("carInsuranceInformation");

    navigate("/merchant/managecars/carinfo");
  };
  // //------------------------------------------------------------------
  // const [showErrorModal, setShowErrorModal] = useState(false);
  // const [errorMessage, setErrorMessage] = useState<string>("");
  const [showAcceptConfirmationModal, setShowAcceptConfirmationModal] =
    useState(false);

  const [acceptConfirmationMessage, setAcceptConfirmationMessage] =
    useState("");

  const mutationDelete = useMutation({
    mutationFn: (userData: ProductDelete) =>
      axiosInstance.put(API_URL.PRODUCT_DELETE, userData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    onSuccess: (successResponse) => {
      //window.location.reload();
      mutation.mutate({
        merchant_id: merchantId,
        business_area: businessArea,
        status: selectedStatus || "PENDING",
      });
      console.log("successResponse", successResponse);
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        alert(error?.data?.message);
      }
      mutation.mutate({
        merchant_id: merchantId,
        business_area: businessArea,
        status: selectedStatus || "PENDING",
      });
    },
  });

  const handleDeleteProducts = () => {
    if (selectedCheckboxes.length === 0) {
      return;
    }

    setDeletePayload({
      merchant_id: merchantId,
      category_id: "",
      product_ids: selectedCheckboxes,
      is_enable: false,
    });
    handleOpenConfirmationModal("Delete the product?");
    //mutationDelete.mutate(deletePayload);
  };

  const handleDeleteItem = (productId: string) => {
    setDeletePayload({
      merchant_id: merchantId,
      category_id: "",
      product_ids: [productId],
      is_enable: false,
    });

    handleOpenConfirmationModal("Delete the product?");
  };
  const handleOpenConfirmationModal = (message: string) => {
    setAcceptConfirmationMessage(message);
    setShowAcceptConfirmationModal(true);
  };
  //-------------------------------------------------------------------

  const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const handleCheckboxChange = (productId: string) => {
    setSelectedCheckboxes((prevState) => {
      if (prevState.includes(productId)) {
        const updatedCheckboxes = prevState.filter(
          (name) => name !== productId
        );

        return updatedCheckboxes;
      } else {
        const updatedCheckboxes = [...prevState, productId];

        return updatedCheckboxes;
      }
    });
  };

  const location = useLocation();
  const pathname = location.pathname;
  const shouldShowDiv = pathname === "/merchant/managecars";

  return (
    <div className="row pt-5">
      <div className="col-md-12">
        {shouldShowDiv && (
          <div className="row">
            <div className="dashboard-button-right pe-5 d-flex justify-content-end">
              <button
                className={`dashboard-modal-button ${
                  showCreateProduct ? "active" : ""
                }`}
                onClick={handleUploadModalOpen}
              >
                <span className="px-1">
                  <Plus size={18} />
                  Upload Excel
                </span>
              </button>
              <button className="dashboard-modal-button" onClick={handleAddCar}>
                <span className="px-1">
                  <Plus size={18} />
                  Add a Car
                </span>
              </button>

              <button
                className="dashboard-modal-button"
                onClick={handleDeleteProducts}
              >
                <span className="px-1">
                  <Trash size={20} />
                </span>
              </button>
              <button className="dashboard-modal-button">
                <span className="px-1">
                  <ThreeDots size={20} /> More
                </span>
              </button>
            </div>
          </div>
        )}

        <div className="row">
          <div className="text-start div-sort-managecarlist">
            <select
              name="status"
              id=""
              className="merchant-input-style-create-product-selectbox-managecarlist"
              onChange={handleStatusChange}
              value={selectedStatus}
            >
              {/* <option value="ALL">ALL</option> */}
              <option value="APPROVED">APPROVED</option>
              <option value="PENDING">PENDING</option>
            </select>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-12 dashboard-table-div">
            <table className="table table-hover dashboard-table">
              <thead>
                <tr>
                  {shouldShowDiv && <th></th>}
                  <th>#</th>
                  <th>Car Name</th>
                  <th>Status</th>
                  <th>Colour</th>
                  <th>Reg:Number</th>
                  <th>Model Year </th>
                  <th>Availability</th>
                  {/* <th >Last 7 Days</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {carList &&
                  carList?.map((car, index: number) => (
                    <tr key={index}>
                      {shouldShowDiv && (
                        <td>
                          <CustomCheckBox
                            isChecked={selectedCheckboxes.includes(
                              car.product_id
                            )}
                            onChange={() =>
                              handleCheckboxChange(car.product_id)
                            }
                          />
                        </td>
                      )}
                      <td>{index + 1}</td>
                      <td>{car?.product_name}</td>
                      <td
                        className={
                          car?.status === "PENDING"
                            ? "status-colour-red"
                            : "status-colour-green"
                        }
                      >
                        {car?.status}
                      </td>
                      <td>{car?.product_details_car?.car_color}</td>
                      <td>{car?.product_details_car?.register_number}</td>
                      <td>{car?.product_details_car?.model_year}</td>
                      <td>
                        <div className="manage-car-list-availability">
                          <span>
                            {car.record_status === 1 ? "Active" : "Inactive"}
                          </span>
                          <label className="manage-car-list-switch">
                            <input
                              type="checkbox"
                              checked={car.record_status === 1}
                              disabled={statusMutation.isPending}
                              onChange={(event) =>
                                handleCarAvailabilityChange(car, event)
                              }
                            />
                            <span className="manage-car-list-slider" />
                          </label>
                        </div>
                      </td>
                      <td className="table-action-btn">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                            className="Dropdown-table"
                          >
                            <img
                              src={dashboard_vertical_three_dots}
                              width="15"
                              height="15"
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="Dropdown-table-item">
                            <Dropdown.Item className="Dropdown-table-list Dropdown-table-border-top">
                              <Link
                                to="#"
                                className="nav-link Dropdown-table-item-link"
                                onClick={() => handleDeleteItem(car.product_id)}
                              >
                                Delete
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item className="Dropdown-table-list Dropdown-table-border-bottom">
                              <Link
                                to={`/merchant/managecars/list/${car.product_id}`}
                                className="nav-link Dropdown-table-item-link"
                              >
                                View / Edit
                              </Link>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {carList?.length > 0 && (
  <Pagination className="pagination-align">
    <Pagination.Prev
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 0}
    />
    {visiblePages.map((pageNum, index) => (
      pageNum === -1 ? (
        <Pagination.Ellipsis key={`ellipsis_${index}`} />
      ) : (
        <Pagination.Item
          key={pageNum}
          active={pageNum === currentPage}
          onClick={() => handlePageChange(pageNum)}
        >
          {pageNum + 1}
        </Pagination.Item>
      )
    ))}
    <Pagination.Next
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage === totalPages - 1}
    />
  </Pagination>
)}
          </div>
        </div>
        <CreateProduct
          isOpen={showCreateProduct}
          onClose={() => setShowCreateProduct(false)}
        />
      </div>
      <ConfirmationModal
        isOpen={showAcceptConfirmationModal}
        onClose={() => setShowAcceptConfirmationModal(false)}
        // onConfirm={() => {
        //   mutationDelete.mutate(deletePayload);
        //   setShowAcceptConfirmationModal(false);
        // }}
        onConfirm={() => {
          if (deletePayload) {
            mutationDelete.mutate(deletePayload);
          }
          setShowAcceptConfirmationModal(false);
        }}
        message={acceptConfirmationMessage}
      />
    </div>
  );
};

export default ManageCarList;
